module.exports = __webpack_public_path__ + "img/application_error_icon.6fc7d43f.svg";